import { FC, memo } from 'react';
import Link from 'next/link';
import { useIntl } from 'react-intl';

const LogotypeFooter: FC = () => {
  const { formatMessage } = useIntl();

  return (
    <Link href={'/'} passHref>
      <a title={formatMessage({ id: 'logotype.linkTitle', defaultMessage: 'Go to homepage' })}>
        <img src='/images/logo-footer.png' alt='Forté logo' />
      </a>
    </Link>
  );
};

export default memo(LogotypeFooter);
